import React from "react";
import { useQuery, gql } from "@apollo/client";
import { useParams } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  makeStyles,
} from "@material-ui/core";

const GET_COLLEGE_INFO = gql`
  query Query($getCollegeInfoCollegeId: String) {
    getCollegeInfo(collegeId: $getCollegeInfoCollegeId)
  }
`;

const useStyle = makeStyles({
  gradient: {
    background: "rgb(97,136,232)",
    // eslint-disable-next-line no-dupe-keys
    background:
      "linear-gradient(90deg, rgba(97,136,232,1) 0%, rgba(0,161,255,1) 50%, rgba(0,145,175,1) 100%)",
  },
});

export function Ranking() {
  const { collegeId } = useParams();
  const classes = useStyle();

  const { loading, error, data } = useQuery(GET_COLLEGE_INFO, {
    fetchPolicy: "cache-first",
    variables: {
      getCollegeInfoCollegeId: collegeId,
    },
  });

  if (loading) {
    return (
      <Box>
        <CircularProgress style={{ color: "#3699FF" }} />
      </Box>
    );
  }

  let collegeDetails = !error ? JSON.parse(data.getCollegeInfo) : {};

  const rankings = Object.keys(collegeDetails)
    .filter((k) => k.startsWith("rankings"))
    .map((key) => ({ key, value: collegeDetails[key] }));

  return (
    <>
      <Card className="mb-5">
        <CardContent>
          <Typography variant="h4" className="text-center" color="primary">
            {collegeDetails.name + " Rankings"}
          </Typography>
        </CardContent>
      </Card>

      <Card className="mb-5">
        <CardContent>
          <Box display="flex" flexWrap="wrap" justifyContent="center">
            {rankings.map((obj) => (
              <Box
                width="20%"
                className="m-4 p-2"
                border={1}
                borderRadius={5}
                borderColor="primary"
              >
                <Box
                  height="80px"
                  width="100%"
                  classes={{ root: classes.gradient }}
                ></Box>
                <Typography variant="h6" color="primary">
                  Best College Athletics
                </Typography>
                <Typography variant="h6" color="initial">
                  {obj.key
                    ? "#" + obj.value.value + " of " + obj.value.total
                    : "--"}
                </Typography>
              </Box>
            ))}
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
